import {ThemeProvider} from 'styled-components';

import {_theme} from './theme';

type Props = {
  children: React.ReactNode;
};
export function AppThemeProvider(props: Props): React.JSX.Element {
  return <ThemeProvider theme={_theme}>{props.children}</ThemeProvider>;
}

AppThemeProvider.displayName = 'AppThemeProvider';
